import React from "react";

interface SizeProps {
  height?: string;
  width?: string;
}

export default function SignUpBonusIcon(props: SizeProps) {
  return (
    <svg
      width={props.width || "32px"}
      height={props.height || "32px"}
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="51" cy="51" r="51" fill="#D2BD00" />
      <path
        d="M71.875 56.375V40.375H58.25L63.875 47.875L59.5 51C54.1667 43.75 51.1667 39.6667 50.5 38.75C49.8333 39.6667 46.8333 43.75 41.5 51L37.125 47.875L42.75 40.375H29.125V56.375H71.875ZM71.875 69.625V64.375H29.125V69.625H71.875ZM44.375 30.5C43.875 29.9167 43.25 29.625 42.5 29.625C41.75 29.625 41.125 29.9167 40.625 30.5C40.125 31 39.875 31.625 39.875 32.375C39.875 33.125 40.125 33.75 40.625 34.25C41.125 34.75 41.75 35 42.5 35C43.25 35 43.875 34.75 44.375 34.25C44.875 33.75 45.125 33.125 45.125 32.375C45.125 31.625 44.875 31 44.375 30.5ZM60.375 30.5C59.875 29.9167 59.25 29.625 58.5 29.625C57.75 29.625 57.125 29.9167 56.625 30.5C56.125 31 55.875 31.625 55.875 32.375C55.875 33.125 56.125 33.75 56.625 34.25C57.125 34.75 57.75 35 58.5 35C59.25 35 59.875 34.75 60.375 34.25C60.875 33.75 61.125 33.125 61.125 32.375C61.125 31.625 60.875 31 60.375 30.5ZM71.875 35C73.375 35 74.625 35.5417 75.625 36.625C76.625 37.625 77.125 38.875 77.125 40.375V69.625C77.125 71.125 76.625 72.4167 75.625 73.5C74.625 74.5 73.375 75 71.875 75H29.125C27.625 75 26.375 74.5 25.375 73.5C24.375 72.4167 23.875 71.125 23.875 69.625V40.375C23.875 38.875 24.375 37.625 25.375 36.625C26.375 35.5417 27.625 35 29.125 35H35C34.6667 33.8333 34.5 32.9583 34.5 32.375C34.5 30.2083 35.2917 28.3333 36.875 26.75C38.4583 25.1667 40.3333 24.375 42.5 24.375C45.25 24.375 47.4583 25.5417 49.125 27.875L50.5 29.75L51.875 27.875C52.4583 26.875 53.4167 26.0417 54.75 25.375C56.0833 24.7083 57.3333 24.375 58.5 24.375C60.6667 24.375 62.5417 25.1667 64.125 26.75C65.7083 28.3333 66.5 30.2083 66.5 32.375C66.5 32.9583 66.3333 33.8333 66 35H71.875Z"
        fill="white"
      />
    </svg>
  );
}
